import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { SimuladorIncentivoOR } from "./SimuladorIncentivoOR";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import CellTowerIcon from "@mui/icons-material/CellTower";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import StarsIcon from "@mui/icons-material/Stars";
import SimuladorNumericInput from "./SimuladorNumericInput";
import BathroomIcon from '@mui/icons-material/Bathroom';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';

const SimuladorIncentivosFormVendedor = ({ puesto }) => {
  const [formData, setFormData] = useState({
    incentivo_maquinaria: 0,
    incentivo_paquete_maquinaria: 0,
    incentivo_prodaliados: 0,
    incentivo_ams: 0,
    incentivo_paquete_ams: 0,
    incentivo_posventa: 0,
    incentivo_seminuevo: 0,
    incentivo_riego: 0,
    porcentaje_prod_riego: 0,
    incentivo_proyecto: 0,
    procentaje_proy_riego: 0,
    riego_venta_total: 0,
    incentivo_gestion: 0,
    incentivo: 0,
  });

  const [totalMaquinaria, setTotalMaquinaria] = useState(0)
  const [totalPA, setTotalPA] = useState(0)
  const [totalAMS, setTotalAMS] = useState(0)
  const [totalPostventa, setTotalPostventa] = useState(0)

  const [state, setState] = useState({
    paquete_maquinaria: 0,
    paquete_ams: 0,
    seminuevos: 0,
    riego_productos: 0,
    riego_proyectos: 0,
    porc_inc_riego_productos: 0,
    porc_inc_riego_proyectos: 0,
    facturacion_crm: 0,
    cartera: 0,
  });

  const handleChange = ({ target }) => {
    setState({
      ...state,
      [target.name]: target.value,
    });
  };
  useEffect(() => {
    const porcentajeProdRiego =
      state.riego_productos >= 750000 ? 0.01 : 0.005;
    const porcentajeProyRiego =
      state.riego_proyectos >= 750000 ? 0.02 : 0.01;

    let incentivoGestion = 0;
    if (Number(state.facturacion_crm) >= 95 && Number(state.cartera) >= 95) incentivoGestion += 2000;

    setFormData(prev => ({
      ...prev,
      incentivo_maquinaria: totalMaquinaria,
      incentivo_paquete_maquinaria: state.paquete_maquinaria * 2000,
      incentivo_prodaliados: totalPA,
      incentivo_ams: totalAMS,
      incentivo_paquete_ams: state.paquete_ams * 2000,
      incentivo_posventa: totalPostventa,
      incentivo_seminuevo: state.seminuevos * 0.008,
      riego_venta_total: Number(state.riego_productos) + Number(state.riego_proyectos),
      porcentaje_prod_riego: porcentajeProdRiego,
      porcentaje_proy_riego: porcentajeProyRiego,
      incentivo_riego: Number(state.riego_productos) * porcentajeProdRiego,
      incentivo_proyecto: Number(state.riego_proyectos) * porcentajeProyRiego,
      incentivo_gestion: incentivoGestion,
    }));
  }, [state, totalMaquinaria, totalPA, totalAMS, totalPostventa, state.seminuevos, state.riego_productos, state.riego_proyectos, state.facturacion_crm, state.cartera]);
  return (
    <>
      <div className="simulador-incentivo-form-seccion">
        <div className="simulador-incentivo-vendedor-f5">
          <div className="fila-title-b">
            <AgricultureIcon /> Maquinaria
          </div>
          <SimuladorIncentivoOR
            rango={[
              { minimo: 0, maximo: 79.99, porcentaje: 0.0030 },
              { minimo: 80, maximo: 99.99, porcentaje: 0.0040 },
              { minimo: 100, maximo: 119.99, porcentaje: 0.0065 },
              { minimo: 120, maximo: 149.99, porcentaje: 0.0085 },
              { minimo: 150, maximo: 100000, porcentaje: 0.0100 },
            ]}
            setTotal={setTotalMaquinaria}
          />

          <div className="simulador-incentivo-separador"></div>

          <div className="simulador-incentivo-vendedor-f3">
            <div className="fila-subtitle">Tractores en paquete</div>
            <div className="input-section-container-numeric">
              <div className="input-container-one">
                <div className="input-section">
                  <div className="input-section-label">
                    Número de paquetes del mes (#)
                  </div>
                  <SimuladorNumericInput
                    name="paquete_maquinaria"
                    label=""
                    value={state.paquete_maquinaria}
                    disabled={false}
                    onChange={handleChange}
                    icono="numero"
                  />
                </div>
              </div>
              <div className="input-container-one">
                <div className="input-section">
                  <div className="input-section-label-incentive">Tu incentivo es de:</div>
                  <SimuladorNumericInput
                    name="paquetes_maquinaria"
                    label=""
                    value={formData.incentivo_paquete_maquinaria}
                    disabled={true}
                    icono="pesos"
                    inputTotal="si"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="simulador-incentivo-vendedor-f5">
          <div className="fila-title-b">
            <GroupWorkIcon sx={{ fontSize: "18px" }} /> Productos Aliados
          </div>
          <SimuladorIncentivoOR
            rango={[
              { minimo: 0, maximo: 79.99, porcentaje: 0.0050 },
              { minimo: 80, maximo: 99.99, porcentaje: 0.0065 },
              { minimo: 100, maximo: 119.99, porcentaje: 0.0100 },
              { minimo: 120, maximo: 149.99, porcentaje: 0.0120 },
              { minimo: 150, maximo: 100000, porcentaje: 0.0130 },
            ]}
            setTotal={setTotalPA}
          />
        </div>
        <div className="simulador-incentivo-vendedor-f5">
          <div className="fila-title-b">
            <CellTowerIcon sx={{ fontSize: "18px" }} /> AMS
          </div>
          <SimuladorIncentivoOR
            rango={[
              { minimo: 0, maximo: 79.99, porcentaje: 0.0040 },
              { minimo: 80, maximo: 99.99, porcentaje: 0.0050 },
              { minimo: 100, maximo: 119.99, porcentaje: 0.0070 },
              { minimo: 120, maximo: 149.99, porcentaje: 0.0090 },
              { minimo: 150, maximo: 100000, porcentaje: 0.0110 },
            ]}
            setTotal={setTotalAMS}
          />

          <div className="simulador-incentivo-separador"></div>

          <div className="simulador-incentivo-vendedor-f3">
            <div className="fila-subtitle">Autoguiados y drones</div>
            <div className="input-section-container-numeric">
              <div className="input-container-one">
                <div className="input-section">
                  <div className="input-section-label">
                    Número de autoguiados y drones del mes (#)
                  </div>
                  <SimuladorNumericInput
                    name="paquete_ams"
                    label=""
                    value={state.paquete_ams}
                    disabled={false}
                    onChange={handleChange}
                    icono="numero"
                  />
                </div>
              </div>

              <div className="input-container-one">
                <div className="input-section">
                  <div className="input-section-label-incentive">Tu incentivo es de:</div>
                  <SimuladorNumericInput
                    name="incentivo_paquete_ams"
                    label=""
                    value={formData.incentivo_paquete_ams}
                    disabled={true}
                    icono="pesos"
                    inputTotal="si"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="simulador-incentivo-vendedor-f5">
          <div className="fila-title-b">
            <StarsIcon /> Servicio de postventa
          </div>
          <SimuladorIncentivoOR
            rango={[
              { minimo: 0, maximo: 99.99, porcentaje: 0.0200 },
              { minimo: 100, maximo: 100000, porcentaje: 0.0300 }
            ]}
            setTotal={setTotalPostventa}
          />
        </div>
        <div className="simulador-incentivo-vendedor-f5">
          <div className="fila-title-b">
            <AgricultureIcon /> Seminuevos
          </div>
          <div className="simulador-incentivo-vendedor-input">
            <div className="input-container-one">
              <div className="input-section">
                <div className="input-title-label">Venta real</div>
                <SimuladorNumericInput
                  name="seminuevos"
                  label=""
                  value={state.seminuevos}
                  disabled={false}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="input-container-one">
              <div className="input-section">
                <div className="input-title-label">% incentivo a ganar</div>
                <SimuladorNumericInput
                  name="meta"
                  label=""
                  value={0.8}
                  disabled={true}
                  icono="porcentaje"
                  align="centro"
                // onChange={handleChange}
                />
              </div>
            </div>
            <div className="input-container-one">
              <div className="input-section">
                <div className="input-title-label-incentive">Tu incentivo es de:</div>
                <SimuladorNumericInput
                  name="meta"
                  label=""
                  inputTotal="si"
                  value={state.seminuevos * 0.008}
                  disabled={true}
                // onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="simulador-incentivo-vendedor-f5">
          <div className="fila-title-b">
            <BathroomIcon /> Sistemas de riego
          </div>
          <div className="simulador-incentivo-vendedor-input">
            <div className="input-container-duo">
              <div className="input-section">
                <div className="input-title-label">Venta de Cinta, ace y otros</div>
                <SimuladorNumericInput
                  name="riego_productos"
                  label=""
                  value={state.riego_productos}
                  disabled={false}
                  onChange={handleChange}
                />
              </div>
              <div className="input-section">
                <div className="input-title-label">Venta de Proyectos del mes</div>
                <SimuladorNumericInput
                  name="riego_proyectos"
                  label=""
                  value={state.riego_proyectos}
                  disabled={false}
                  // icono="porcentaje"
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="input-container-duo">
              <div className="input-section">
                <div className="input-title-label">Venta total del mes</div>
                <SimuladorNumericInput
                  name="venta_total"
                  label=""
                  value={formData.riego_venta_total}
                  disabled={true}
                  align="centro"
                  onChange={handleChange}
                />
              </div>
              <div className="input-section">
                <div className="input-title-label">% incentivo a ganar Prod.Riego</div>
                <SimuladorNumericInput
                  name="porcentaje_inc_producto"
                  label=""
                  icono="porcentaje"
                  value={formData.porcentaje_prod_riego * 100}
                  disabled={true}
                  align="centro"
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="input-container-one">
              <div className="input-section">
                <div className="input-title-label-incentive">Tu incentivo es de:</div>
                <SimuladorNumericInput
                  name="incentivo_prod_riego"
                  label=""
                  inputTotal="si"
                  value={formData.incentivo_riego}
                  disabled={true}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="input-container-one">
              <div className="input-section">
                <div className="input-title-label">% incentivo a ganar Proy.Riego</div>
                <SimuladorNumericInput
                  name="porcentaje_inc_proyectos"
                  label=""
                  value={formData.porcentaje_proy_riego * 100}
                  align="centro"
                  disabled={true}
                  icono="porcentaje"
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="input-container-one">
              <div className="input-section">
                <div className="input-title-label-incentive">Tu incentivo es de:</div>
                <SimuladorNumericInput
                  name="incentivo_proy_riego"
                  label=""
                  value={formData.incentivo_proyecto}
                  disabled={true}
                  inputTotal="si"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="simulador-incentivo-vendedor-f5">
          <div className="fila-title-b">
            <ManageSearchIcon /> Indicadores de gestión
          </div>
          <div className="simulador-incentivo-vendedor-input">
            <div className="input-container-duo">
              <div className="input-section">
                <div className="input-title-label">Facturación incluyendo geolocalización en CRM</div>
                <SimuladorNumericInput
                  name="facturacion_crm"
                  label=""
                  value={state.facturacion_crm}
                  disabled={false}
                  icono="porcentaje"
                  onChange={handleChange}
                />
              </div>
              <div className="input-section">
                <div className="input-title-label">Cartera de clientes actualizada</div>
                <SimuladorNumericInput
                  name="cartera"
                  label=""
                  value={state.cartera}
                  disabled={false}
                  icono="porcentaje"
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="input-container-one">
              <div className="input-section">
                <div className="input-title-label-incentive">Tu incentivo es de:</div>
                <SimuladorNumericInput
                  name="incentivo_gestion"
                  label=""
                  inputTotal="si"
                  value={formData.incentivo_gestion}
                  disabled={false}
                // onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>

      </div>

      <div className="simulador-incentivo-nuevoformat">
        <div className="simulador-incentivo-form-titulos">
          <span>
            Considerando los datos ingresados, tu Incentivo total simulado es:
          </span>
          <div className="simulador-incentivo-form-titulo-input">
            <SimuladorNumericInput
              name="incentivo_total"
              label=""
              value={
                formData.incentivo_maquinaria +
                formData.incentivo_paquete_maquinaria +
                formData.incentivo_prodaliados +
                formData.incentivo_ams +
                formData.incentivo_paquete_ams +
                formData.incentivo_posventa +
                formData.incentivo_seminuevo +
                formData.incentivo_riego +
                formData.incentivo_proyecto +
                formData.incentivo_gestion +
                formData.incentivo
              }
              disabled={true}
              align="centro"
            // onChange={handleChange}
            />
          </div>
        </div>
        <div className="simulador-incentivo-form-titulo-leyenda">
          Este simulador presenta escenarios de compensación estimados con base en los resultados ingresados. Su contenido no representa información oficial ni compromiso de pago
        </div>
      </div>
    </>
  );
};

export default SimuladorIncentivosFormVendedor;
